import React from 'react'

const SvgDatePicker = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_1087_1093)">
        <path d="M14.9993 3.32812H4.99935C3.1584 3.32812 1.66602 4.82051 1.66602 6.66146V14.9948C1.66602 16.8357 3.1584 18.3281 4.99935 18.3281H14.9993C16.8403 18.3281 18.3327 16.8357 18.3327 14.9948V6.66146C18.3327 4.82051 16.8403 3.32812 14.9993 3.32812Z" stroke="#6366F1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.66602 1.66406V4.9974M13.3327 1.66406V4.9974M1.66602 8.33073H18.3327" stroke="#6366F1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1087_1093">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgDatePicker